import styles from './GuidanceCard.scss';
import Icon from '@xo-union/tk-component-icons';
import React from 'react';

interface TextGuidanceCardProps {
  title: string;
  body: string;
  className?: string;
}

const TextGuidanceCard = ({ title, body }: TextGuidanceCardProps) => {
  return (
    <>
      <div className={styles.cardContent}>
        <div className={styles.title}>
          <span className={styles.titleText}>{title}</span>
          <Icon name="arrow_right_2" size="sm" className={styles.arrowIconSm} />
          {/*
            Note the two arrow icons: in some cases, cards require an
            always-in-header arrow icon. This is a design choice/behavior that is not
            consistent across all cards.
           */}
          <Icon name="arrow_right_2" size="sm" className={`${styles.arrowIconMd} ${styles.arrowIconHeader}`} />
        </div>
        <div className={styles.cardBody}>{body}</div>
      </div>
      <Icon name="arrow_right_2" size="md" className={`${styles.arrowIconMd} ${styles.arrowIconBody}`} />
    </>
  );
};

export default TextGuidanceCard;
